import { render } from "./Sv023.vue?vue&type=template&id=f3e98172&scoped=true"
import script from "./Sv023.vue?vue&type=script&lang=js"
export * from "./Sv023.vue?vue&type=script&lang=js"

import "./Sv023.vue?vue&type=style&index=0&id=f3e98172&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f3e98172"]])

export default __exports__